import { render } from "./RaportCard.vue?vue&type=template&id=22c38142&scoped=true"
import script from "./RaportCard.vue?vue&type=script&lang=js"
export * from "./RaportCard.vue?vue&type=script&lang=js"

import "./RaportCard.vue?vue&type=style&index=0&id=22c38142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c38142"]])

export default __exports__